<template>
    <div>

        <!-- Manage user form !-->
        <b-modal id="telegram-id" title="Link your Telegram id to 3proj" :hide-footer="true" no-close-on-backdrop>
            <TelegramID @close="$bvModal.hide('telegram-id')"></TelegramID>
        </b-modal>

    </div>
</template>


<script>

    import TelegramID from './TelegramID'

    /**
     * Tasks object
     */
    export default {

        components: {TelegramID},

        // On create
        created() {

        },


        // Component creation event
        mounted() {

            // Load actions
            this.$dispatch('auth/loadUsersActions').then(data => {

                // Show dialog
                for(let actId of data) this.$bvModal.show(actId);

            })
        },

        // Data
        data() {
            return {};
        },

        // Computed vars
        computed: {},

        // Some methods
        methods:
            {

            }
    }
</script>
